import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Home from "../../views/home";
import LiveTv from "../../views/liveTv";
import Navbar from "../navbar";
import TvGuide from "../../views/tvGuide/TvGuide";
import GridView from "../../views/gridView/GridView";
import Search from "../search";
import TivibuSettings from "../TivibuSettings/TivibuSettings";
import Language from "../language";
import VersionInfo from "../versionInfo";
import NotificationsSettings from "../notificationsSettings";
import DeviceManagement from "../deviceManagement";
import ParentalControl from "../parentalControl";
import PurchaseHistory from "../purchaseHistory";
import PackageList from "../packageList";
import ContentFilterSettings from "../contentFilter/ContentFilterSettings";
import SuggestionComplain from "../suggestioncomplain/SuggestionComplain";
import UserRecords from "../userRecords/UserRecords";
import LockedChannel from "../lockedChannels";
import ModalRouting from "../modalRouting/ModalRouting";
import { NotFoundPage } from "../status/StatusView";
import DashboardRedirect from "./DashboardRedirect";
import Footer from "../footer";
import ChatbotComponent from "../chatbotComponent/ChatBotComponent";
import VodDetailModal from "../newVodDetail/VodDetailModal";
import {
  useVodModalRoute,
  VodBackgroundContext,
  VOD_DETAIL_PATH
} from "../newVodDetail/vodModalNavigation";
import CatchupVodDetail from "../catchupVodDetail";
import CatchupGridView from "../../views/catchupGridView";
import SettingsFrame from "../settings/SettingsFrame";
import GuidePrewarm from "./GuidePrewarm";
import { CatalogShell } from "../cinema/CatalogTheme";

const Routing = () => {
  const detail = useVodModalRoute();
  return (
    <CatalogShell location={detail.background}>
      <GuidePrewarm />
      <VodBackgroundContext.Provider value={detail.open}>
        <div
          className="atlas-browse-layer"
          inert={detail.open ? "" : undefined}
          aria-hidden={detail.open ? true : undefined}
        >
          <Route location={detail.background}>
            <Navbar />
            <SettingsFrame>
              {detail.open && !detail.hasBackground ? (
                <div className="vod-direct-backdrop" />
              ) : (
                <Switch location={detail.background}>
                  <Route
                    path={`/dashboard/catchupdetail/:vodId`}
                    component={CatchupVodDetail}
                  />
                  <Route
                    path={`/dashboard/catchup/:menuId/:categoryId`}
                    component={CatchupGridView}
                  />
                  <Route
                    path={`/dashboard/home/:menuId/:categoryId`}
                    component={Home}
                  />
                  <Route
                    path={`/dashboard/livetv/:channelNo`}
                    component={LiveTv}
                  />
                  <Route path={`/dashboard/tvguide`} component={TvGuide} />
                  <Route
                    path={`/dashboard/settings`}
                    component={TivibuSettings}
                  />
                  <Route path={`/dashboard/language`} component={Language} />
                  <Route path={`/dashboard/version`} component={VersionInfo} />
                  <Route
                    path={`/dashboard/notifications`}
                    component={NotificationsSettings}
                  />
                  <Route
                    path={`/dashboard/devices`}
                    component={DeviceManagement}
                  />
                  <Route
                    path={`/dashboard/purchasehistory`}
                    component={PurchaseHistory}
                  />
                  <Route
                    path={`/dashboard/suggestioncomplaint`}
                    component={SuggestionComplain}
                  />
                  <Route
                    path={`/dashboard/parentalcontrol`}
                    component={ParentalControl}
                  />
                  <Route path={`/dashboard/records`} component={UserRecords} />
                  <Route path="/dashboard/package" component={PackageList} />
                  <Route path="/dashboard/contentfilter" component={ContentFilterSettings} />
                  <Route
                    path={`/dashboard/favlockchannel`}
                    component={LockedChannel}
                  />
                  <Route
                    path={`/dashboard/genre/:columnCode/:columnName`}
                    component={GridView}
                  />
                  <Route path={`/dashboard/search/:term?`} component={Search} />
                  <Redirect
                    path={`/dashboard/livetv`}
                    to={`/dashboard/livetv/all`}
                  />
                  <Route
                    exact
                    path={["/dashboard", "/dashboard/home"]}
                    component={DashboardRedirect}
                  />
                  {/* These overlays are rendered by ModalRouting below. */}
                  <Route
                    path={[
                      "/dashboard/payment/:programId",
                      "/dashboard/program/:id"
                    ]}
                    render={() => null}
                  />
                  <Route render={() => <NotFoundPage size="section" />} />
                </Switch>
              )}
            </SettingsFrame>
            <ModalRouting />

            <Footer />
            <ChatbotComponent />
          </Route>
        </div>
      </VodBackgroundContext.Provider>
      {detail.open && (
        <Route
          path={VOD_DETAIL_PATH}
          render={() => (
            <VodDetailModal
              onClose={detail.close}
              background={detail.background}
            />
          )}
        />
      )}
    </CatalogShell>
  );
};

export default Routing;
